import { actions, selectors } from '../../../../../../state/';
import { createStore } from '@updater-core/lib/store';
import { codeLens } from '../../data';
import { STATES } from '../../../../../../constants/';
import { track, SUBMIT } from '@updater-core/lib/tracker';
import { formatPromotionForEventStream } from '../../eventstream';
import { filterPromosByPlacements } from './data';
import { view } from 'ramda';

/*
 * Temporary
 * sourceId = 7 is for FYM Offers page
 */
const sourceId = 7;

function trackUnlockDeals(promos) {
  promos.forEach((promo) => {
    const event = {
      verb: SUBMIT,
      object: 'unlock_deal',
      domain: 'promotions',
      segmentEventName: 'Submitted Promotions Unlock Deal',
      details: {
        sourceId,
        promotionId: promo.promotion.id,
        entityId: promo.validFor[0].id,
        entityName: promo.validFor[0].name,
        code: view(codeLens, promo.promotion),
        promotionCode: view(codeLens, promo.promotion),
        promotion: formatPromotionForEventStream(
          promo.promotion,
          promo.validFor[0]
        ),
        source: 'forward_mail',
      },
    };

    track(event);
  });
}

export function claimPromotions(promos, updStore) {
  const selectedPromos = promos.filter((promo) => promo.selected);
  trackUnlockDeals(selectedPromos);
  return updStore.dispatch(
    actions.promotions.claimPromotions(
      selectedPromos.map((promo) => promo.promotion.id),
      'forward_mail'
    )
  );
}

export function togglePromos(id, promos) {
  return [
    ...promos.map((promo) =>
      promo?.promotion?.id === id
        ? {
            ...promo,
            selected: !promo.selected,
          }
        : promo
    ),
  ];
}

export const updatePromotions = (
  newPromotions = [],
  oldPromotions = [],
  placement,
  promotionType
) => {
  return [
    ...(
      filterPromosByPlacements(newPromotions, placement, promotionType) || []
    ).map((promo) => {
      const currentPromotion = oldPromotions.find(
        (oldPromo) => oldPromo.promotion.id === promo.promotion.id
      );
      return {
        ...currentPromotion,
        ...promo,
        selected: currentPromotion ? currentPromotion.selected : false,
        claiming: currentPromotion ? currentPromotion.claiming : false,
      };
    }),
  ];
};

export function createPromotionsListInteractor({
  source,
  promotions,
  updStore,
  placement,
  promotionType,
}) {
  let store = createStore({
    promotions: updatePromotions(promotions),
    claiming: false,
    hidden: true,
    loading: true,
    source,
  });
  updStore
    .dispatch(actions.promotions.fetchPromotionsNow())
    .then(() => store.setState({ loading: false }));

  const state = updStore.getState();
  const moveId = selectors.current.move(state).id(state);

  const goToEOPage = () =>
    updStore.dispatch(actions.router.stateGo(STATES.STEP_PROMOTIONS));

  return {
    moveId,
    subscribe: store.subscribe,
    getState: store.getState,
    destroy: () => {},
    goToEOPage,
    claimPromotions: () => {
      const state = store.getState();
      store.setState({
        claiming: true,
        promotions: [
          ...state.promotions.map((promo) =>
            promo.selected
              ? {
                  ...promo,
                  claiming: true,
                }
              : promo
          ),
        ],
      });
      return claimPromotions(state.promotions, updStore).then(() => {
        const state = store.getState();
        store.setState({
          claiming: false,
          promotions: [
            ...state.promotions.map((promo) => ({
              ...promo,
              selected: false,
              claiming: false,
            })),
          ],
        });
      });
    },
    togglePromoSelection: (id) => {
      const promos = store.getState().promotions;
      const promotions = togglePromos(id, promos);
      store.setState({
        promotions,
      });
    },
    numberOfDealsSelected: () =>
      store
        .getState()
        .promotions.reduce(
          (count, promo) => (promo.selected ? count + 1 : count),
          0
        ),
    getPromotions: () => store.getState().promotions,
    setPromotions: (promotions) =>
      store.setState({
        promotions: updatePromotions(
          promotions,
          store.getState().promotions,
          placement,
          promotionType
        ),
      }),
    claiming: () => store.getState().claiming,
    loading: () => store.getState().loading,
    setHidden: (hidden) => store.setState({ hidden }),
    isHidden: () => store.getState().hidden,
    source: () => store.getState().source,
  };
}
